import { CtrlSex } from "@/components/Ctrl/Sex"
import { Input } from "@/components/Form/Input"
import { useVerifyPersonalForm } from "@usher/pe-client-front-end-lib"
import { FormattedMessage, useIntl } from "react-intl"
import countries from "react-intl-tel-input-18/dist/components/AllCountries"

export const PersonalVerificationForm = () => {
  const { $t: t } = useIntl()
  const { client, formMethods, onSubmit, country } = useVerifyPersonalForm()
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = formMethods

  return (
    <div id="details" className="tab-pane fade show active">
      <h4 className="h4 application-form__text">
        <FormattedMessage id="pa_183" />
      </h4>
      <p className="application-form__title mb-xs bg-main-main/10">
        <FormattedMessage id="pa_184" />
      </p>
      <form onSubmit={handleSubmit(onSubmit)} className="aplication-form">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Input.Form disabled name="email" defaultValue={client.email} control={control} label={t({ id: "pa_185" })} />
          </div>
          <div>
            <Input.Form disabled name="phone" defaultValue={client.phone} control={control} label={t({ id: "pa_186" })} />
          </div>
          <div>
            <Input.Form
              rules={{
                required: true,
                minLength: 2,
                pattern: /^[a-zA-Z\s]*$/,
              }}
              disabled
              name="first_name"
              defaultValue={client.first_name}
              control={control}
              label={t({ id: "pa_187" })}
            />
          </div>
          <div>
            <Input.Form disabled name="last_name" defaultValue={client.last_name} control={control} label={t({ id: "pa_188" })} />
          </div>
          <div className="mt-2">
            <label className="label sm:mb-4">
              <FormattedMessage id="pa_189" />:
            </label>
            <CtrlSex disabled {...register("sex", { required: true })} value={1} current={client.sex ?? 1} intlId="pa_56" />
            <CtrlSex disabled {...register("sex", { required: true })} value={2} current={client.sex ?? 1} intlId="pa_57" />
          </div>
          <div>
            <Input
              disabled
              label={t({ id: "pa_190" })}
              value={countries.getCountries().find((count) => (count.iso2 === "gb" ? "uk" : count.iso2) === country.toLowerCase())?.name}
            />
          </div>
          <div>
            <Input.Form name="zip" control={control} label={t({ id: "pa_191" })} defaultValue={client.zip} disabled />
          </div>
          <div>
            <Input.Form name="address" control={control} label={t({ id: "pa_192" })} defaultValue={client.address} disabled />
          </div>
          <div>
            <Input.Form
              disabled
              rules={{
                required: true,
                minLength: 2,
                pattern: /^[a-zA-Z\s]*$/,
              }}
              name="state"
              control={control}
              label={t({ id: "pa_193" })}
              defaultValue={client.state}
              required
            />
          </div>

          <div>
            <Input.Form
              disabled
              name="city"
              control={control}
              label={t({ id: "pa_194" })}
              defaultValue={client.city}
              required
              rules={{
                minLength: 2,
                pattern: /^[a-zA-Z\s]*$/,
              }}
            />
          </div>
        </div>
      </form>
    </div>
  )
}
